import React, { useEffect, Component, Fragment, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import { DateUtil } from "../../../datas/DateUtil";
import { FxmsData } from "../../../datas/FxData";
import { width } from "@mui/system";
import { FaceRetouchingOffSharp } from "@mui/icons-material";
import {DataSelecter} from "./DataSelecter";

HighchartsMore(Highcharts);

/**
 * 라인 챠트
 * 개발자 : 김영상
 * 개발년원 : 2023.2
 * @param {*} fxUiGrp
 * @param {*} fxUiGrpItem
 * @returns
 */
export const FxPieChart = (props) => {

  const { id, fxUiGrp, fxUiGrpItem, editable } = props;
  const [title, setTitle] = useState('')
  const [titleSensor, setTitleSensor] = useState("");
  const [titlePsItem, setTitlePsItem] = useState("");
  //list
  const [sensorList, setSensorList] = useState(props.sensorList)
  const [psItemList, setPsItemList] = useState(props.psItemList)
  //selected
  const [psItem, setPsItem] = useState('');
  const [sensor, setSensor] = useState('');

  const [ranges, setRanges] = useState([]);
  const [averages, setAverages] = useState([]);
  const [intervalId, setIntervalId] = useState(null);

  //chart
  const [yAxis, setYAxis] = useState('')
  const [unit, setUnit] = useState('')
  const [datas, setDatas] = React.useState([]);

  useEffect(() => {
    if(props.item.fxUiDashbItemAttrs){
      if(props.item.fxUiDashbItemAttrs.length > 0) {
        setTitle(props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'title') ? props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'title').attrVal:'')
        let tempSensor = props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'sensor') ? props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'sensor').attrVal : ''
        let tempPsItem = props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'psItem') ? props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'psItem').attrVal : ''
        if(tempSensor != ''){
          handleSensorChange({target:{value:parseInt(tempSensor)}})
        }
        if(tempPsItem != ''){
          handlePsItemChange({target:{value:tempPsItem}})
        }
      }
    }

  }, []);
  const showDatas = (sensorId,psId) => {
    FxmsData.GET("fxmsPs/minMaxAgvList", {
      moNo: sensorId,
      psId: psId,
    }).then(res=>{
      let averages = [];
      let ranges = [];
      let data = []
      let result = res.data.result;
      if (result) {
        result.forEach((value, index, result) => {
          if ((index = 0)) {
            data.push({
              name: value.psDate,
              y: value.avgValue,
              sliced: true,
              selected: true,
            });
          } else {
            data.push({ name: value.psDate, y: value.avgValue });
          }
        });
        //y값은 100으로 비율을 나눠서 저장해야 함.
        setDatas(data);
      } else {
        setTitleSensor(sensor.moName + " 데이터 조회 오류!!");
        setTitlePsItem(psItem.psName + " 데이터 조회 오류!!");
      }
    });
  }
  const getData = (id,name) => {
    if(name === "sensor"){
      showDatas(id,psItem)
    }else if(name === "psItem"){
      showDatas(sensor,id)
    }

  }
  const handleSensorChange = (e) => {
    setSensor(e.target.value)
    setTitleSensor(sensorList.find(x=>x.moNo===e.target.value) ? sensorList.find(x=>x.moNo===e.target.value).moDispName : '')
    if(psItem != ''){
      if(intervalId){
        clearInterval(intervalId)
      }
      const intId = setInterval(getData.bind(this,e.target.value,'sensor'),100000)
      setIntervalId(intId)
      getData(e.target.value,'sensor')
    }
  }
  const handlePsItemChange = (e) => {
    setPsItem(e.target.value)
    setTitlePsItem(psItemList.find(x=>x.psId===e.target.value) ? psItemList.find(x=>x.psId===e.target.value).psName : '')
    setUnit(psItemList.find(x=>x.psId===psItem) ? psItemList.find(x=>x.psId===psItem).psUnit:'')
    if(sensor != ''){
      if(intervalId){
        clearInterval(intervalId)
      }
      const intId = setInterval(getData.bind(this,e.target.value,'psItem'),100000)
      setIntervalId(intId)
      getData(e.target.value,'psItem')
    }
  }
  const handleTitleChange = (e) => {
    setTitle(e.target.value)
  }
  const saveCurrentData = () => {
    let currentData = []
    currentData.push({uiNo:props.item.uiNo,attrName:'title',attrVal:title,attrType:'string'})
    currentData.push({uiNo:props.item.uiNo,attrName:'psItem',attrVal:psItem,attrType:'string'})
    currentData.push({uiNo:props.item.uiNo,attrName:'sensor',attrVal:sensor,attrType:'string'})
    props.save(currentData,props.item.uiNo,props.item.opId)
  }
  const removeItem = () => {
    props.removeItem(props.item.uiNo)
  }
  return (
      <>
        {props.editable ? <DataSelecter mode={'pie'} sensorList={sensorList} sensor={sensor} psItem={psItem} psItemList={psItemList} handleCloseAndSave={saveCurrentData} handleTitleChange={handleTitleChange} handleSensorChange={handleSensorChange} handlePsItemChange={handlePsItemChange} removeItem={removeItem}/>: '' }
        <HighchartsReact
            className="HighChart"
            containerProps={{ style: { width: "100%", height: "100%" } }}
            highcharts={Highcharts}
            options={{
              chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: "pie",
                backgroundColor: "rgba(255,255,255, 0.1)",
              },
              title: {text: title, style: { color: "white" },},
              subtitle: {text: titleSensor+" :: "+titlePsItem, style: { color: "white" },},
              tooltip: {pointFormat: "{titleSensor}: <b>{point.percentage:.1f}%</b>",},
              accessibility: {point: {valueSuffix: "%",},},
              plotOptions: {
                pie: {
                  allowPointSelect: true,
                  cursor: "pointer",
                  dataLabels: {
                    enabled: true,
                    format: "<b>{point.name}</b>: {point.percentage:.1f} %",
                  },
                },
              },
              series: [
                {
                  name: titlePsItem,
                  colorByPoint: true,
                  data: datas,
                },
              ],
            }}
        />
      </>

  );
};

export default FxPieChart;